import { MutableRefObject, useCallback } from 'react';

import { IconButton as ButtonIcon, Tooltip } from '@material-ui/core';

import { RiCheckLine, RiFileCopyLine } from '@remixicon/react';
import type { Editor as TiptapEditor } from '@tiptap/core';

import { useCopyToClipboard } from '@spotify/confidence-core-react';

import { useCollaborativeDocumentContext } from '../contexts';
import { getDocumentMarkdown } from '../utils';

export const CopyAsMarkdownButton = ({
  editorRef,
  iconSize = 16,
  iconColor,
}: {
  editorRef?: MutableRefObject<TiptapEditor | null>;
  iconSize?: number;
  iconColor?: string;
} = {}) => {
  const { collaborativeDocument } = useCollaborativeDocumentContext();
  const { copied, copy } = useCopyToClipboard();

  const handleCopy = useCallback(() => {
    const text = getDocumentMarkdown({
      editor: editorRef?.current,
      markdown: collaborativeDocument?.markdown,
      content: collaborativeDocument?.content,
    });
    if (text) {
      void copy(text);
    }
  }, [
    editorRef,
    collaborativeDocument?.markdown,
    collaborativeDocument?.content,
    copy,
  ]);

  return (
    <Tooltip title="Copy as markdown">
      <ButtonIcon
        aria-label="Copy as markdown"
        onClick={handleCopy}
        size="small"
        style={iconColor ? { color: iconColor } : undefined}
      >
        {copied ? (
          <RiCheckLine size={iconSize} />
        ) : (
          <RiFileCopyLine size={iconSize} />
        )}
      </ButtonIcon>
    </Tooltip>
  );
};
